angular.
module("dx.webapp.masterTools").
controller("DxDXEToDXRConverterController", function DXEToDXRConverterController(
	$window
) {
	"use strict";

	this.inputDXE = "";
	this.outputDXR = "";
	this.error = "";

	this.convert = function convert() {
		this.error = "";
		this.outputDXR = "";
		if (this.inputDXE) {
			try {
				var dxr = decodeDXEToDXR(this.inputDXE);
				this.outputDXR = JSON.stringify(dxr, null, 4);
			} catch (err) {
				this.error = err.message;
			}
		} else {
			this.error = "No DXE file content has been specified";
		}
	};

	// using the browser atob causes UTF characters to end up incorrect
	// this base64 decode works as intended
	function b64DecodeUnicode(str) {
		return decodeURIComponent(Array.prototype.map.call($window.atob(str), function reduce(c) {
			return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(""));
	}

	function decodeDXEToDXR(encodedData) {
		var decoded = b64DecodeUnicode(encodedData);
		var dxe = JSON.parse(decoded);
		var answers = dxe.questions.map(function getAnswer(q) {
			return q.answer;
		});

		var dxr = {
			examId: dxe.id,
			studentId: dxe.studentId,
			state: 2,
			studentCode: dxe.studentCode,
			firstName: dxe.firstName,
			lastName: dxe.lastName,
			email: dxe.email,
			answers: answers,
		};

		return dxr;
	}
});
